module.exports = __webpack_public_path__ + "static/img/IMG_20150307_164019.8f423ade.jpg";